<template>
  <b-row class="wait-project">
    <b-col
      cols="12"
      md="4"
      v-for="(item, index) in data.slice(0, 6)"
      :key="index"
    >
      <img
        :src="getImgUrl(item.projectPhotoUrl)"
        @click="ProjectDetail(item.id)"
      />
      <div class="wait-content" @click="ProjectDetail(item.id)">
        <h5 class="maxLength-text-1">
          {{ item.name ? item.name : "" }}
        </h5>
        <div class="flex-text">
          <div class="projects-flex-text">
            <span>项目类型</span>
            <Category :categoryId="item.categoryId"></Category>
          </div>
          <div class="projects-flex-text">
            <span>项目行业</span>
            <p v-if="item.industry">{{ item.industry.name }}</p>
          </div>
          <div class="projects-flex-text">
            <span>开始时间</span>
            <p>{{ changeDataTime(item.startDate) }}</p>
          </div>
        </div>
        <p v-html="item.projectRequire" class="p-16-6 wait-desc"></p>
        <div
          class="projects-wait-footer"
          v-if="item.areas && item.areas.length > 0"
        >
          <i></i>
          <span>
            {{ existData(item.areas[0], "provinceName", "") }}
            {{
              item.areas[0] && item.areas[0].cityName
                ? existData(item.areas[0], "cityName", " - ")
                : ""
            }}
          </span>
        </div>
      </div>
    </b-col>
  </b-row>
</template>
<script>
import publicChange from "@/assets/js/index.js";
import Category from "@/components/category.vue";
export default {
  data() {
    return {};
  },
  props: {
    data: {
      type: Array
    },
    ProjectDetail: {
      type: Function
    }
  },
  components: {
    Category
  },
  methods: {
    onDesc(text) {
      return publicChange.disposeHtml(text);
    },
    getImgUrl(img) {
      return publicChange.getStaticUrl(img);
    },
    existData(data, index, text) {
      return publicChange.existData(data, index, text);
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    //转换时间戳
    changeDataTime(date) {
      let time = new Date(date);
      return this.$moment(time).format("YYYY.MM.DD");
    }
  }
};
</script>
<style scoped></style>
